import { all } from '@awesome.me/kit-2cbcf7d4a0/icons';
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
    init: () => {
        library.add({ ...all });
    },
};
